import React from 'react';
import { AppSideBar } from '../bars/side-bar/SideBar';
import Header from '../bars/Header';
import styled from 'styled-components';
import { Col } from 'reactstrap';
import { AppBarProvider } from '../../../context/AppBarContext';
import InternalAppBar from '../bars/InternalAppBar';

const Section = styled.div`
  height: calc(100vh - 70px); // adjust the '70px' to account for your header's height
  overflow-y: auto;
  background-color: rgb(242, 245, 247);
`;

class AppLayout extends React.Component {
  state = {
    appBarConfig: { title: '', actions: [] },
  };

  setAppBarConfig = (config) => {
    this.setState({ appBarConfig: config });
  };


  render() {
    const { children } = this.props;
    const { appBarConfig } = this.state;
    return (
      <main className='cr-app'>
        {/*<Sidebar />*/}
        <AppSideBar />
        <Col style={{ padding: 0 }}>
          <Header history={this.props.history} />
          <AppBarProvider >
          <InternalAppBar title={appBarConfig.title} actions={appBarConfig.actions} />
          <Section id='main-body-container' className='custom-scrollbar'>
            {children}

          </Section>
        </AppBarProvider>
      </Col>

  </main>
  )
    ;
  }
}

export default AppLayout;
